// extracted by mini-css-extract-plugin
export default {"downloadButton":"DownloadButton_downloadButton__H4ITo"};